import { render, staticRenderFns } from "./CrudSelectiveProcess.vue?vue&type=template&id=1980091e&scoped=true&"
import script from "./CrudSelectiveProcess.vue?vue&type=script&lang=js&"
export * from "./CrudSelectiveProcess.vue?vue&type=script&lang=js&"
import style0 from "./CrudSelectiveProcess.vue?vue&type=style&index=0&id=1980091e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1980091e",
  null
  
)

export default component.exports